import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FiberDvrIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fiber_dvr"}/>
}
